import { render } from "./newMonture.vue?vue&type=template&id=3e2e7639&scoped=true"
import script from "./newMonture.vue?vue&type=script&lang=js"
export * from "./newMonture.vue?vue&type=script&lang=js"

import "./newMonture.vue?vue&type=style&index=0&id=3e2e7639&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2e7639"]])

export default __exports__